export const mapStageTypesToStages = (stages, stageTypesByStageIds) =>
  stages.map(stage => ({
    ...stage,
    venue_type: stageTypesByStageIds[stage.backstage_external_id],
  }));
